/** Precision for rounding floating-point numbers (4 decimal places).
 *  Filters out noise from OrbitControls damping and Three.js internals. */
const PRECISION = 4
const FACTOR = 10 ** PRECISION

/** JSON replacer that rounds numbers to PRECISION decimal places.
 *  Prevents floating-point drift (e.g. camera position) from producing false diffs. */
const roundingReplacer = (_key: string, value: unknown): unknown => {
  if (typeof value === 'number') return Math.round(value * FACTOR) / FACTOR
  return value
}

/** Stable JSON.stringify that rounds all numbers to fixed precision.
 *  Use for dirty-checking comparisons where floating-point noise must be ignored. */
export const stableStringify = (value: unknown): string => JSON.stringify(value, roundingReplacer)
